import React, { useMemo } from "react";
import DataTable from "../../components/data-table";
import { getStatusColors, formatRate } from "./performanceUtils";

const columns = [
  {
    key: "rank",
    label: "Rank",
    sortable: true,
    width: "80px",
    render: (value) => <span className="font-semibold text-app-muted">#{value}</span>,
  },
  {
    key: "user.email",
    label: "Assignee",
    sortable: true,
    searchable: true,
    render: (value) => (
      <span className="block max-w-[220px] truncate font-medium text-app-primary" title={value || ""}>
        {value || "—"}
      </span>
    ),
  },
  {
    key: "project",
    label: "Project",
    sortable: true,
    searchable: true,
    accessor: (row) => row.project?.projectName || "All Projects",
  },
  {
    key: "totalOutput",
    label: "Screener Responses",
    sortable: true,
    align: "right",
    render: (value) => <span className="font-semibold text-app-primary">{value}</span>,
  },
  { key: "totalEffort", label: "Total Effort", sortable: true, align: "right" },
  {
    key: "conversionRate",
    label: "Conversion Rate",
    sortable: true,
    align: "right",
    render: (value) => formatRate(value),
  },
  {
    key: "status",
    label: "Status",
    sortable: true,
    searchable: true,
    render: (value) => {
      const colors = getStatusColors(value);
      return (
        <span className={`inline-block rounded-full border px-2.5 py-1 text-xs font-semibold ${colors.bg} ${colors.text} ${colors.border}`}>
          {value}
        </span>
      );
    },
  },
];

function LeaderboardSection({ data, isLoading }) {
  // Rank comes from the server's ordering, so it stays fixed when the table is re-sorted.
  const rows = useMemo(() => data.map((entry, index) => ({ ...entry, rank: index + 1 })), [data]);

  return (
    <section className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm dark:border-slate-700 dark:bg-slate-900/50 dark:shadow-none space-y-3">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100">Full Leaderboard</h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-slate-400">Ranked by screener responses, then conversion rate.</p>
      </div>

      <DataTable
        ariaLabel="Full leaderboard"
        columns={columns}
        data={rows}
        getRowId={(row) => `${row.userId}-${row.project?.id ?? "all"}`}
        loading={isLoading}
        searchable
        searchPlaceholder="Search assignee, project or status"
        pagination
        defaultPageSize={10}
        labels={{ empty: "No performance data available." }}
      />
    </section>
  );
}

export default LeaderboardSection;
